// src/components/Loader.js
import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="ball-with-shadow">
        <img src="/assets/images/ball-removebg-preview.png" className="loader-image" alt="Loading..." />
        <div className="ball-shadow"></div>
      </div>
    </div>
  );
};

export default Loader;
